<template>
    <div id="app">
        <Navbar ref="nav" />
        <router-view v-on:showLogin="showLogin" :key="componentKey" />
        <Footer v-on:showLogin="showLogin" />
    </div>
</template>

<script>
    import Navbar from "@/views/components/Navbar"
    import Korkeakoulu from "@/views/Korkeakoulu"
    import Footer from "@/views/components/Footer"
    import HeroStart from "@/views/components/HeroStart"
    import secretStore from './utils/localstorage'

    export default {
        data() {
            return {
                componentKey: 0,
            };
        },
        name: 'app',
        components: {
            Footer,
            Navbar,
            Korkeakoulu,
            HeroStart
        },
        created: function () {
            console.debug("Init the store")
            secretStore.initStore(() => {
                this.forceRerender()
            })
        },
        methods: {
            forceRerender() {
               this.componentKey += 1;  
            },
            showLogin() {
                this.$refs.nav.showModal()
            }
        }
    }
</script>
<style lang="scss">
    @import "./css/style";
</style>


// WEBPACK FOOTER //
// src/App.vue